import { lazy, type ComponentType } from 'react';

// After a deploy, an open tab may ask for a file from the previous build that no
// longer exists. For a whole page (Let Go, AI Companion, Dashboard) the safe fix
// is to reload once and get the new build, instead of crashing. At most once a
// minute, so a real outage can't cause a reload loop.
const KEY = 'zuzu_chunk_reload';

export function lazyWithReload<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) { // eslint-disable-line @typescript-eslint/no-explicit-any
  return lazy(async () => {
    try {
      return await load();
    } catch (err) {
      let last = 0;
      try { last = Number(sessionStorage.getItem(KEY) || 0); } catch { /* storage blocked */ }
      if (Date.now() - last > 60_000) {
        try { sessionStorage.setItem(KEY, String(Date.now())); } catch { /* storage blocked */ }
        window.location.reload();
        return new Promise<never>(() => {}); // the page is reloading
      }
      throw err;
    }
  });
}
